import { useConfigStore } from "../../stores/ConfigStore";
import { useLanguage } from "../../stores/LanguageStore";
import { useProfileStore } from "../../stores/UserStore";

function htmlEncode(str) {
  if (str) {
    return String(str).replace(/[^\w. ]/gi, function (c) {
      return '&#' + c.charCodeAt(0) + ';';
    });
  }
  return ""
}

export function replaceTokens({ otherTokens = [], text = "", signHtml = "", contact, shouldEncode = true, noTokenReplace, redVariables }) {
  const replacements = useProfileStore.getState().profile?.datafields_replacement
  const lang = useLanguage.getState().language;
  let result = text || "";
  let tokens = [...useConfigStore.getState().datafields, ...otherTokens];

  tokens.push(
    {
      identifier_placeholder: "%unsubscribe%",
      name: lang.components.variable_manager.dialog.unsubscribe_variable_name,
    },
    {
      identifier_placeholder: "%webversion%",
      name: lang.components.variable_manager.dialog.webversion_variable_name,
    }
  );

  tokens.forEach((token) => {
    const contact_value = contact?.properties?.find(
      (x) => x.data_field_id === token.id || x.id === token.id
    )?.value;

    let replacement = replacements?.find(x => x.datafield_id === token.id)?.replacement

    result = result.replaceAll(
      token.identifier_placeholder,
      shouldEncode ?
        htmlEncode(`${contact_value || replacement || ""}`) || (noTokenReplace ? "" : (redVariables ? `<span style="color: red;">[${token.name}]</span>` : `[${token.name}]`))
        :
        `${contact_value || replacement || (noTokenReplace ? "" : `[${token.name}]`)}`
    );
  });

  if (result.includes("%signature%")) {
    result = result.replaceAll("%signature%", signHtml || (noTokenReplace ? "" : `[SIGNATURE]`));
  } else result += signHtml;

  return result.trim();
}
